// Copyright (c) 2017 Deere & Company

export default {
    name: 'OPEN_PART_REQUESTS',
    onEnter: (nextState, replace) => replace('/part-requests/open'),
    path: 'open-part-requests'
};



// WEBPACK FOOTER //
// ./src/routes/tcsm/reports/open-part-requests.js